module.exports = __webpack_public_path__ + "static/media/4 Rajendra 2019 MI Alert.7ae66d99.pdf";